import React from 'react';
import Notification from './Notification';
import './NotificationContainer.css';

const NotificationContainer = ({ notifications, onClose }) => {
  if (!notifications || notifications.length === 0) return null;

  return (
    <div className="notification-container">
      {notifications.map((notification, index) => (
        <Notification
          key={notification.id || index}
          notification={notification}
          onClose={() => onClose(notification.id)}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;

